<app-content>
  <app-breadcrumbs>
    <li>
      Konsultacje społeczne
    </li>
  </app-breadcrumbs>
  <section>
    @if (successMessage) {
      <br>
      <app-alert type="success" (onClose)="successMessage = undefined">{{ successMessage }}</app-alert>
    }
    <h2>
      Konsultacje społeczne
    </h2>
    @if (!loading()) {
      <div class='row'>
        <div class='col-md-6'>
          <div class='form-group'>
            <label for='name'>Szukaj konsultacji społecznych</label>
            <input autocomplete='off' [(ngModel)]='filterValue' id='name' type='text'
                   placeholder='Wpisz nazwę konsultacji społecznych' />
          </div>
        </div>
      </div>
      <div class='row'>
        <div class='col-md-8'>
          <ul class='item-list'>
            <li style='max-width: fit-content'
                *ngFor='let item of surveys() | filterData: filterValue : false : "title"'>
              <div>
                <a
                  [routerLink]='"/konsultacje-spoleczne/" + item.uuid'>
                  {{ item?.title || 'Nieznana ankiketa' }}
                </a>
                @if (!!item?.active && !item?.publishResults) {
                  <span class="ms-1 color--green d-inline-flex align-items-center">
                    <i aria-hidden="true" class="fa fa-info-circle me-2"></i><small style="margin-bottom: 0.15rem">(Konsultowane)</small>
                  </span>
                } @else {
                  <span class="ms-1 color--light-blue d-inline-flex align-items-center">
                    <i aria-hidden="true" class="fa fa-info-circle me-2"></i><small style="margin-bottom: 0.15rem">(Opublikowano wyniki)</small>
                  </span>
                }
                @if (!item?.active) {
                  <span class="ms-1 color--dark-red d-inline-flex align-items-center">
                    <i aria-hidden="true" class="fa fa-info-circle me-2"></i><small style="margin-bottom: 0.15rem">(Nie aktywna)</small>
                  </span>
                }
              </div>
              <div>
                <small>
                  <app-label label="Kategoria:">Infrastruktura rekreacyjna</app-label>
                </small>
              </div>
              <div>
                <small>
                  <app-label label="Numer:">1/2025</app-label>
                  &nbsp;
                  <app-label label="Typ konsultacji:">Ankieta</app-label>
                </small>
              </div>
              <div>
                <small>
                  <app-label label="Data rozpoczęcia:">1.12.2025</app-label>
                  &nbsp;
                  <app-label label="Data zakończenia:">31.12.2025</app-label>
                </small>
              </div>
            </li>
          </ul>
          @if (!(surveys() | filterData: filterValue : false : "title").length) {
            <app-alert content='Brak zdefiniowanych Konsultacji społecznych' [closable]='false'>
            </app-alert>
          }
        </div>
      </div>
    } @else {
      <app-spinner>
        Poczekaj trwa ładowanie danych...
      </app-spinner>
    }
  </section>
</app-content>
